<template>
  <div class="dhr-sideview no-padding">
    <div class="subparts-menu" v-if="data.length != 0">
      <div 
        v-for="(step, index) in this.data" 
        :key="index"
        class="menu-link"
        :class="{'link active active-line': selectedOrder == step.order || hoveredStep == step.order}"
        @mouseover="hoverRow(step.order)"
        @mouseout="hoverRow(null)"
        @click="selectRow(step.stepID, step.order)"
      >
        {{ step.name }}
      </div>
    </div>

    <div class="subparts-menu" v-else>
      <div 
        class="menu-link link active active-line"
      >
        {{ "Sample step" }}
      </div>
    </div>
  </div>
</template>

<script>
import BaseIcon from "@/components/base/Icon";

export default {
  components: {
    BaseIcon,
  },
   
  props: {
    data: Array
  },
  mounted() {
    this.selectRow(this.data[0].stepID, this.data[0].order)
  },
  data() {
    return {
      selectedStep: 1,
      selectedOrder: 1,
      hoveredStep: null
    };
  },
  methods: {
    selectRow(stepID, stepOrder) {
      this.selectedStep = stepID
      this.selectedOrder = stepOrder
      this.$emit("selectedStep", {"id": stepID, "order": stepOrder});
    },
    hoverRow(stepID) {
      this.hoveredStep = stepID
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/style/base.scss";
@import "@/style/pages/dhrdetail.scss";
@import "@/style/components/active.scss";

</style>